import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    DETECTION_CATALOG_EXPORT?: boolean;
    DETECTION_CATALOG_TEST_ENV_REQUIRES_VPN?: boolean;
    DETECTION_TYPE_FILTER?: boolean;
  }
}

export default {
  featureFlags: {
    // AWN-320841
    DETECTION_CATALOG_EXPORT: undefined,
    DETECTION_CATALOG_TEST_ENV_REQUIRES_VPN: undefined,
    // S2CX-15011
    DETECTION_TYPE_FILTER: true,
  },
} satisfies FeatureFlagConfig;
